import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Upload, User, ListChecks, Briefcase } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  if (!user) return null;
  // Hide on workspace
  if (location.pathname.startsWith('/workspace')) return null;

  const isTranscriber = user.role === 'transcriber' || user.role === 'admin';

  const NAV_ITEMS = [
    { path: '/', label: 'Home', icon: Home },
    { path: '/upload', label: 'Upload', icon: Upload },
    { path: '/account', label: 'Account', icon: User },
    { path: '/tasks', label: 'Tasks', icon: ListChecks },
    ...(isTranscriber ? [{ path: '/transcriber', label: 'Work', icon: Briefcase }] : []),
  ];

  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 w-full h-16 md:h-20 bg-white/80 backdrop-blur-xl border-t border-black/10 flex justify-around items-center z-[9999]"
    >
      {NAV_ITEMS.map(({ path, label, icon: Icon }) => {
        const active = location.pathname === path;
        return (
          <button
            key={path}
            data-testid={`nav-${label.toLowerCase()}`}
            onClick={() => navigate(path)}
            className={`flex flex-col items-center justify-center gap-1 min-w-[64px] transition-colors ${
              active ? 'text-[var(--brand-primary)]' : 'text-[var(--brand-text-sec)] hover:text-[var(--brand-text)]'
            }`}
          >
            <Icon size={24} strokeWidth={active ? 2.5 : 1.5} />
            <span className="text-xs font-medium">{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
